<template>
<m-pageframe
    title="Automated Messages"
>
<v-container>

    <v-list-item
        v-for="(item, index) in pages"
        :key="index"
        v-on:click="onClickPage(item)"
    >
        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon><v-icon>mdi-arrow-right</v-icon></v-list-item-icon>
    </v-list-item>

</v-container>
</m-pageframe>
</template>

<script>
export default {

    mounted () {
        
        if ( this.pages.length == 1 )
        {
            this.onClickPage(this.pages[0]);
        }
    },

    methods: {
        onClickPage(page) {
            this.$router.push({
                'name': page.page,
                'params' : {
                    'organization_id': this.$route.params.organization_id
                }
            });
        }
    },

    computed: {

        pages() {
            let ret = [];

            ret.push(
                {
                    'title': 'Settings',
                    'icon': 'mdi-cog',
                    'page': 'auto-messages-settings'
                }
            );

            ret.push(
                {
                    'title': 'View / Search Automated Messages',
                    'icon': 'mdi-forum',
                    'page': 'auto-messages-search-all-messages'
                }
            );

            ret.push(
                {
                    'title': 'Events',
                    'icon': 'mdi-xml',
                    'page': 'events',
                }
            );
           
            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>